import { ISkinTrack } from '../ISkinTrack'
import { Limb } from '../Limb'

export const GET_SKIN_TRACK_REQUEST = 'GET_SKIN_TRACK_REQUEST'
export const GET_SKIN_TRACK_SUCCESS = 'GET_SKIN_TRACK_SUCCESS'
export const GET_SKIN_TRACK_FAILURE = 'GET_SKIN_TRACK_FAILURE'

export const ADD_MARK = 'ADD_MARK'
export const MOVE_MARK = 'MOVE_MARK'
export const DELETE_MARK = 'DELETE_MARK'

export const SET_NOTE = 'SET_NOTE'

export const REQUEST_START = 'REQUEST_START'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'

interface GetSkinTrackRequest {
  type: typeof GET_SKIN_TRACK_REQUEST
}

interface GetSkinTrackSuccess {
  type: typeof GET_SKIN_TRACK_SUCCESS
  payload: {
    skinTrack: ISkinTrack
    customerUuid: string
    limb: Limb
  }
}

interface GetSkinTrackFailure {
  type: typeof GET_SKIN_TRACK_FAILURE
}

interface AddMark {
  type: typeof ADD_MARK
  payload: {
    skinTrackId: string
    markId: number
    left: number
    top: number
    color: string
  }
}

interface MoveMark {
  type: typeof MOVE_MARK
  payload: {
    skinTrackId: string
    markId: number
    left: number
    top: number
  }
}

interface DeleteMark {
  type: typeof DELETE_MARK
  payload: {
    skinTrackId: string
    markId: number
  }
}

interface SetNote {
  type: typeof SET_NOTE
  payload: {
    skinTrackId: string
    note: string
  }
}

interface RequestStart {
  type: typeof REQUEST_START
}

interface RequestSuccess {
  type: typeof REQUEST_SUCCESS
}

export type ActionTypes =
  | GetSkinTrackRequest
  | GetSkinTrackSuccess
  | GetSkinTrackFailure
  | AddMark
  | MoveMark
  | DeleteMark
  | SetNote
  | RequestStart
  | RequestSuccess
